var navToggle = document.querySelector('.header__nav-toggle');
var nav = document.querySelector('.nav');
var bannerClose = document.querySelector('.header__banner__close');

if (navToggle && nav) {
  navToggle.addEventListener('click', function() {
    nav.classList.toggle('nav--active');
  });
}

if (bannerClose) {
  bannerClose.addEventListener('click', function() {
    var banner = this.parentNode;
    banner.parentNode.removeChild(banner);
    document.body.classList.remove('header-banner');
  });
}
